import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;

  .mlq {
    background-color: #f1d60a;
    display: inline-block;
    margin: 0px 3px 3px 3px;
    padding: 2px 4px;
    border-radius: 4px;
    width: 35px;
    text-align: center;
    color: #4c4f52;
  }

  .news-list {
    li {
      padding: 10px;
      list-style: none;

      &:nth-child(odd) {
        background-color: ${(props) => props.theme.item.odd};
      }
    }
  }

  @media screen and (max-width: 680px) {
    .news-filter {
      flex-wrap: wrap;

      .w-48,
      .w-auto {
        width: calc(50% - 10px);
        margin: 0 5px 8px;
      }

      .w-48,
      .w-auto {
        .MuiButtonBase-root {
          width: 100%;
        }
      }

      .source {
        .MuiAutocomplete-endAdornment {
          top: -15px;
        }
      }
    }
  }
`;
